/**
 * Defines the watchers related to view profile dialog box
 * These watchers will be imported in store/RootSaga.js
 */

import { takeLatest, all } from 'redux-saga/effects';
import { UPDATE_PROFILE_DETAILS, GET_COUNTRIES } from 'constants/ActionTypes';
import { updateProfileDetailsSaga, getCountriesSaga } from './ViewProfileDialog.saga';

export default function* watchers() {
  yield all([
    yield takeLatest(UPDATE_PROFILE_DETAILS, updateProfileDetailsSaga),
    yield takeLatest(GET_COUNTRIES, getCountriesSaga),
  ]);
}
